import { render, staticRenderFns } from "./CreateGiftcardPopup.vue?vue&type=template&id=c8de1dce"
import script from "./CreateGiftcardPopup.vue?vue&type=script&lang=js"
export * from "./CreateGiftcardPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports